// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';

import {InstrumentedCenteredWaveLoader} from '../../utility/InstrumentedLoader';
import {InlineCombobox} from './InlineCombobox/InlineCombobox';
import {InlineComboboxAddItemInput} from './InlineCombobox/InlineComboboxAddItemInput';
import {type MoveRunsAction} from './moveRunsEvents';

export function GroupContent({
  loading,
  hasExistingGroups,
  isCreatingFirstGroup,
  isMovingRuns,
  items,
  label,
  selectedGroup,
  onAddItem,
  setSelectedGroup,
  setIsCreatingFirstGroup,
  trackMoveRunsWithLocation,
}: {
  loading: boolean;
  hasExistingGroups: boolean;
  isCreatingFirstGroup: boolean;
  isMovingRuns: boolean;
  items: Array<{
    name: string;
    isDisabled: boolean;
    disabledMessage: string | undefined;
  }>;
  label: string;
  selectedGroup: string | null;
  onAddItem: (item: string) => void;
  setSelectedGroup: (group: string | null) => void;
  setIsCreatingFirstGroup: (value: boolean) => void;
  trackMoveRunsWithLocation: (action: MoveRunsAction) => void;
}) {
  if (loading) {
    return (
      <InstrumentedCenteredWaveLoader name="load-all-groups" size="small" />
    );
  }

  if (hasExistingGroups) {
    return (
      <InlineCombobox
        disabled={isMovingRuns}
        emptyLabel="No groups match this search"
        emptyDescription="Try another search term or explore available groups."
        // If the user has created a new group, the selected group will not appear in
        // the groups provided by the server, _unless_ they accidentally typed in an
        // existing group name. If they have typed in a new unique name, stick it at
        // the front of the list.
        items={items}
        itemToString={v => v?.name || ''}
        label={label}
        newItemButtonLabel="New group"
        newItemPlaceholder="New group name"
        onAddItem={item => {
          onAddItem(item);
          trackMoveRunsWithLocation('Created group');
        }}
        onSelectedItemChange={item => {
          setSelectedGroup(item?.name ? item.name : null);
        }}
        isItemDisabled={item => item?.isDisabled ?? false}
        disabledItemMessage={item => {
          return item?.disabledMessage;
        }}
        placeholder="Search groups"
        selectedItem={
          selectedGroup ? items.find(item => item.name === selectedGroup) : null
        }
      />
    );
  }

  if (isCreatingFirstGroup) {
    return (
      <div className="flex grow flex-col">
        <InlineComboboxAddItemInput
          disabled={isMovingRuns}
          style={{margin: 0, height: '100%'}}
          onAddItem={item => {
            onAddItem(item);
            trackMoveRunsWithLocation('Created group');
          }}
          onCancelAddItem={() => setIsCreatingFirstGroup(false)}
          placeholder="Type a group name..."
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-10 p-24">
      <p className="text-xl font-semibold">No groups yet</p>
      <p className="text-moon-650">Create a new group to move runs into.</p>
      <Button
        icon="add-new"
        variant="secondary"
        onClick={() => setIsCreatingFirstGroup(true)}>
        New group
      </Button>
    </div>
  );
}
